import { AccountDt, LoginDt, RegisterAccountDt, ResponseMessage, UserProfileDt } from "../../Models/AccountModel";
// import Cookies from "js-cookie";

// export const getAccessToken = () => Cookies.get("cs-auth-dev") || Cookies.get("cs-auth-qa") || Cookies.get("cs-auth");
// export const isAuthenticated = () => !!getAccessToken();


export const signInAccount = async (loginData: LoginDt): Promise<ResponseMessage> => {
  const apiUrl = import.meta.env.VITE_BACKEND_HOST_NAME;

  try {
    const response = await fetch(`${apiUrl}account/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(loginData),
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data: ResponseMessage = await response.json();
    return data;
  } catch (error) {
    console.error("Fetch error:", error);
    return {
      success: false,
      message: "Error signing in user",
    };
  }
};

export const forgotPassword = async (email: string): Promise<ResponseMessage> => {
  const apiUrl = import.meta.env.VITE_BACKEND_HOST_NAME;

  try {
    const response = await fetch(`${apiUrl}account/ForgotPassword`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(email),
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data: ResponseMessage = await response.json();
    return data;
  } catch (error) {
    console.error("Fetch error:", error);
    return {
      success: false,
      message: "Somting went wrong",
    };
  }
};

export const getCurrentUser = async (): Promise<AccountDt> => {
  const apiUrl = import.meta.env.VITE_BACKEND_HOST_NAME;

  try {
    const response = await fetch(`${apiUrl}account/CurrentUser`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data: AccountDt = await response.json();
    return data;
  } catch (error) {
    console.error("Fetch error:", error);
    return {
      userName: "",
      roles: [],
    };
  }
};

export const signOutUser = async (): Promise<ResponseMessage> => {
  const apiUrl = import.meta.env.VITE_BACKEND_HOST_NAME;

  try {
    const response = await fetch(`${apiUrl}account/SignOut`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data: ResponseMessage = await response.json();
    return data;
  } catch (error) {
    console.error("Fetch error:", error);
    return {
      success: false,
      message: "Error signing out user",
    };
  }
};

export const registerUser = async (userData: RegisterAccountDt): Promise<ResponseMessage> => {
  const apiUrl = import.meta.env.VITE_BACKEND_HOST_NAME;

  try {
    const response = await fetch(`${apiUrl}account/Register`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(userData),
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data: ResponseMessage = await response.json();
    return data;
  } catch (error) {
    console.error("Fetch error:", error);
    return {
      success: false,
      message: "Error registering user",
    };
  }
};

export const getUserProfile = async (): Promise<UserProfileDt> => {
  const apiUrl = import.meta.env.VITE_BACKEND_HOST_NAME;

  try {
    const response = await fetch(`${apiUrl}account/Profile`, {
      method: "GET",
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data: UserProfileDt = await response.json();
    return data;
  } catch (error) {
    console.error("Fetch error:", error);
    return {} as UserProfileDt;
  }
};

export const saveUserProfile = async (profileData: UserProfileDt): Promise<ResponseMessage> => {
  const apiUrl = import.meta.env.VITE_BACKEND_HOST_NAME;

  try {
    const response = await fetch(`${apiUrl}account/SaveProfile`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(profileData),
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data: ResponseMessage = await response.json();
    return data;
  } catch (error) {
    console.error("Fetch error:", error);
    return {
      success: false,
      message: "Error registering user",
    };
  }
};
